import { useColors } from '../../hooks/useColors'

type Props = {
  formData: Record<string, string>
  onChange: (key: string, value: string) => void
}

export default function GeneralSettingsTab({ formData, onChange }: Props) {
  const colors = useColors()
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <h3 style={{ margin: 0, color: colors.textPrimary }}>General Settings</h3>
      <input value={formData.business_name || ''} onChange={(e) => onChange('business_name', e.target.value)} placeholder="Business Name" />
      <textarea value={formData.business_address || ''} onChange={(e) => onChange('business_address', e.target.value)} placeholder="Business Address" rows={3} />
      <input value={formData.business_phone || ''} onChange={(e) => onChange('business_phone', e.target.value)} placeholder="Business Phone" />
      <input value={formData.business_email || ''} onChange={(e) => onChange('business_email', e.target.value)} placeholder="Business Email" />
      <input value={formData.gstin || ''} onChange={(e) => onChange('gstin', e.target.value)} placeholder="GSTIN" />
      <input value={formData.gst_rate || ''} onChange={(e) => onChange('gst_rate', e.target.value)} placeholder="GST Rate" />

      <div style={{ marginTop: 12, paddingTop: 12, borderTop: `1px solid ${colors.border}`, display: 'grid', gap: 6 }}>
        <h3 style={{ margin: 0, color: colors.textPrimary }}>Customer Announcement</h3>
        <label htmlFor="announcement_message" style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary }}>
          Announcement Message
        </label>
        <textarea
          id="announcement_message"
          value={formData.announcement_message || ''}
          onChange={(e) => onChange('announcement_message', e.target.value)}
          placeholder="Enter announcement message to display in customer app"
          rows={3}
          maxLength={500}
        />
        <p style={{ margin: 0, fontSize: 12, color: colors.textMuted }}>
          Shows as a banner at the top of the customer app home screen. Leave blank to hide it. Customers see the new text after their app refreshes (within ~5 min). Max 500 characters.
        </p>
      </div>
    </div>
  )
}
